import { type SWRResponse } from 'swr';

import type ApiError from '@/helpers/ApiError';
import { type UseNoodleSwrConfig, useNoodleSwr } from '@/hooks/useNoodleApi';
import { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

const PATH_TEMPLATE = '/quickbooks/{creatorId}/redirect';

export type QuickBooksRedirectUrlApi = ApiDefinition[typeof PATH_TEMPLATE]['GET'];

export const useQuickBooksRedirectUrl = (
  params: QuickBooksRedirectUrlApi['params'] | null,
  config?: UseNoodleSwrConfig<QuickBooksRedirectUrlApi['response']>,
): SWRResponse<QuickBooksRedirectUrlApi['response'], ApiError> => {
  const path = params ? buildPath<QuickBooksRedirectUrlApi>(PATH_TEMPLATE, params) : null;
  return useNoodleSwr(path, { revalidateOnFocus: false, ...config });
};
